import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { GameType } from 'src/app/shared/types/game-type';
import {
  GAME_NAME_MAPPER,
  GAME_ORDER_MAPPER,
} from '@shared/consts/game.consts';
import { UserRole } from '@shared/types/user';
import {
  MENU_ITEMS_BY_TYPE,
  DIVIDER_NAME,
} from '@shared/consts/sidenav-menu.consts';
import { SessionService } from '@services/session.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidenavMenuComponent {
  private session = inject(SessionService);

  @Input() gameType!: GameType;
  @Input() userRole?: UserRole;
  @Input() isMobile!: boolean;
  @Input() isSidenavOpen!: boolean;

  @Output() setGameType = new EventEmitter<GameType>();

  readonly mapper = GAME_NAME_MAPPER;
  readonly roles = UserRole;
  readonly menuItemsByType = MENU_ITEMS_BY_TYPE;
  readonly dividerName = DIVIDER_NAME;
  games$ = this.session.userGames$.pipe(
    map((games) =>
      (games || [])
        .map((game) => ({
          type: game,
          title: GAME_NAME_MAPPER[game],
          position: GAME_ORDER_MAPPER[game],
        }))
        .sort((a, b) => a.position - b.position),
    ),
  );

  constructor() {}

  onSetGameType(gameType: GameType): void {
    this.setGameType.emit(gameType);
  }
}
